import draggable from "vuedraggable";
import "./NewsFilePreview.scss";
import ImagePreview from "@/components/Common/ImagePreview/ImagePreview";

export default {
  name: "NewsFilePreview",
  props: ["files", "showControls", "newsMediaChannels"],
  extends: ImagePreview,
  data: () => ({
    editDialog: false,
    filterTest: "",
    fileToEdit: {
      license: {}
    }
  }),
  components: { draggable },
  computed: {
    cFiles: {
      get() {
        return this.files;
      },
      set(newVal) {
        this.$emit("setFileUrls", newVal);
      }
    },
    generatedPictureUrl() {
      return this.fileToEdit?.picture?.url;
    },
    hasGeneratedPicture() {
      return this.generatedPictureUrl?.length;
    }
  },
  methods: {
    getFilePictureUrl(file) {
      return file?.picture?.url;
    },
    toggleChannel(channelValue) {
      if (this.fileToEdit.channels.includes(channelValue)) {
        this.fileToEdit.channels = this.fileToEdit.channels.filter(item => {
          return item !== channelValue;
        });
        this.fileToEdit.channels.reverse().reverse();
      } else {
        this.fileToEdit.channels.push(channelValue);
      }
    },
    saveDetails() {
      const index = this.cFiles.findIndex(
        file => file.id === this.fileToEdit.id
      );
      this.cFiles[index].title = this.fileToEdit.title;
      this.cFiles[index].channels = this.fileToEdit.channels;
      this.editDialog = false;
    },

    openEditDialog(url) {
      let fileTemp = this.cFiles.find(file => file.url === url);
      if (!fileTemp.license) fileTemp.license = {};
      this.fileToEdit = fileTemp;
      this.fileToEditOriginal = { ...fileTemp };

      this.editDialog = true;
    },
    removeFile(index) {
      this.$emit("removeFile", index);
    }
  }
};
